import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api";

// ---------------------------------------------------------------------------
// Session & RTC token async thunks
// ---------------------------------------------------------------------------

export const fetchTeamSession = createAsyncThunk(
    "teamFocusSession/fetchSession",
    async (teamId: string, { rejectWithValue }) => {
        try {
            const data = await api.teamMode.getSession(teamId);
            return { teamId, data };
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch team session",
            );
        }
    },
);

export const fetchRtcToken = createAsyncThunk(
    "teamFocusSession/fetchRtcToken",
    async (teamId: string, { rejectWithValue }) => {
        try {
            const data = await api.teamMode.getRtcToken(teamId);
            return { teamId, rtcToken: data.rtcToken };
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch RTC token",
            );
        }
    },
);
